export enum ErrorCodes {
  ConnectionFailed = "ConnectionFailed",
  ConnectionStringIsMissing = "ConnectionStringIsMissing"
}